export default __webpack_public_path__ + "static/media/food05.9d7ef710.png";